import { GTM_TRIGGERS } from 'Utilities/analytics';
import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

export const DOCUMENT_CAPTURE_PAGES = Object.freeze({
  ACCEPT_OFFER: 'Accept offer',
  DOCUMENT_CAPTURE_UPLOAD: 'Documents upload',
  DOCUMENTS_BANK_DETAILS: 'Bank Details Form',
  DOCUMENTS_SUMMARY: 'Documents summary',
  PROOF_OF_ADDRESS: 'Proof of address',
  REVIEW_STATUS: 'Review status page',
  SALE_CONFIRMATION: 'Sale confirmation page',
  SALE_DETAILS: 'Sale details page',
  VEHICLE_DETAILS: 'Vehicle details page',
});

export const UPLOAD_DOCUMENTS = 'Upload documents';

export const DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS = Object.freeze({
  ACCEPT_OFFER_BUTTON_CLICK: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'accept_offer_button_clicked',
  }),

  ACCEPT_OFFER_PAGE_LOAD: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'accept_offer_page_loaded',
  }),

  ACCEPT_OFFER_PHONE_CLICK: ({ label, offerType = 'valid' }) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    label,
    name: `phone_number_link_clicked_${offerType}_offer`,
  }),

  ACCEPT_OFFER_WITH_DEALER_RATING_PAGE_LOAD: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'accept_offer_dealer_rating_loaded',
  }),

  BANK_DETAILS_OVERLAY_CONTINUE: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENTS_BANK_DETAILS,
    label: 'Continue overlay button clicked',
    name: 'bank_details_overlay_continue',
  }),

  BANK_DETAILS_OVERLAY_OPENED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENTS_BANK_DETAILS,
    label: 'Continue overlay opened',
    name: 'bank_details_overlay_opened',
  }),

  BID_DETAILS_IN_VIEW: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'bid_details_in_view',
  }),

  COMPARISON_TABLE_IN_VIEW: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'comparison_table_in_view',
  }),

  COMPARISON_TABLE_MODAL_VIEWED: () => GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'comparison_table_modal_viewed',
  }),

  CONFIRM_SALE_BUTTON_ACCEPTED_VALUE: ({ label }) => {
    GTM_TRIGGERS.CONFIRM_SALE_BUTTON_ACCEPTED_VALUE();

    GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
      button_label: 'N/A',
      category: DOCUMENT_CAPTURE_PAGES.SALE_CONFIRMATION,
      label,
      name: 'confirm_sale_button_accepted_value',
      url: 'N/A',
    });
  },

  CONFIRM_SALE_BUTTON_CLICKED: ({ label = 'N/A' }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: label,
    category: DOCUMENT_CAPTURE_PAGES.SALE_CONFIRMATION,
    label,
    name: 'confirm_sale_button_clicked',
    url: 'N/A',
  }),

  CONFIRM_SALE_PAGE_LOAD: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.SALE_CONFIRMATION,
    name: 'Complete my sale page',
  }),

  CONFIRM_SALE_PAGE_LOAD_OLD: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.SALE_CONFIRMATION,
    name: 'Confirm sale page',
  }),

  CONFIRM_SALE_WITH_DEALER_RATING_PAGE_LOAD: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.SALE_CONFIRMATION,
    name: 'confirm_sale_dealer_rating_loaded',
  }),

  DEALER_DETAILS_EMAIL_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.SALE_DETAILS,
    name: 'dealer_details_email_clicked',
  }),

  DEALER_DETAILS_PHONE_NUMBER_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.SALE_DETAILS,
    name: 'dealer_details_phone_number_clicked',
  }),

  DOCUMENTS_BANK_DETAILS_SUBMITTED: ({ label }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'N/A',
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENTS_BANK_DETAILS,
    label,
    name: 'documents_bank_details_submitted',
    url: 'N/A',
  }),

  DOCUMENTS_SUMMARY_BACK_TO_OVERALL_SUMMARY: ({ buttonLabel = 'N/A', url = 'N/A' }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENTS_SUMMARY,
    label: 'N/A',
    name: 'documents_summary_back_to_overall_summary',
    url,
  }),

  DOCUMENTS_UPLOAD_ADD_DOCUMENT_MODAL_CLICKED: ({ buttonLabel, label }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label,
    name: 'documents_upload_add_document_modal_clicked',
    url: 'N/A',
  }),

  DOCUMENTS_UPLOAD_ADD_LATER_CLICKED: ({ buttonLabel, label }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label,
    name: 'documents_upload_add_later_clicked',
    url: 'N/A',
  }),

  DOCUMENTS_UPLOAD_ADD_LATER_MODAL_CLICKED: (documentType) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label: documentType,
    name: 'documents_upload_add_later_modal_clicked',
  }),

  DOCUMENTS_UPLOAD_BUTTON_CLICKED: ({ buttonLabel = 'N/A', label }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label,
    name: 'documents_upload_button_clicked',
    url: 'N/A',
  }),

  DOCUMENTS_UPLOAD_DOCUMENTS_ADDED: ({ buttonLabel = 'N/A', label, url = 'N/A' }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label,
    name: 'documents_upload_documents_added',
    url,
  }),

  DOCUMENTS_UPLOAD_DOCUMENTS_SUBMITTED: ({ label }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'N/A',
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label,
    name: 'documents_upload_documents_submitted',
    url: 'N/A',
  }),

  DOCUMENTS_UPLOAD_EXAMPLE_OVERLAY_OPENED: (title) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label: title,
    name: 'documents_upload_example_overlay_opened',
  }),

  DOCUMENTS_UPLOAD_HELP_OVERLAY_CLICKED: (documentType) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label: documentType,
    name: 'documents_upload_help_overlay_clicked',
  }),

  DOCUMENTS_UPLOAD_NO_IMAGES_ON_SUBMISSION: ({ buttonLabel = 'N/A', label }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label,
    name: 'documents_upload_no_images_on_submission',
    success: false,
    url: 'N/A',
  }),

  DOCUMENTS_UPLOAD_OPENED_ON_TAP_TO_RETRY_CLICKED: (documentType) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label: documentType,
    name: 'documents_upload_opened_on_tap_to_retry_clicked',
  }),

  DOCUMENTS_UPLOAD_PRIVACY_INFORMATION_LINK_CLICKED: (documentType) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label: documentType,
    name: 'documents_upload_privacy_information_clicked',
  }),

  DOCUMENTS_UPLOAD_SUMMARY_TILE_CLICKED: (documentType) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label: documentType,
    name: 'documents_upload_summary_tile_clicked',
  }),

  DOCUMENTS_UPLOAD_TIPS_OVERLAY_BUTTON_CLICKED: ({ label }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Got it',
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label,
    name: 'documents_upload_tips_overlay_button_clicked',
    url: 'N/A',
  }),

  DOCUMENTS_UPLOAD_TIPS_OVERLAY_CLOSE_CLICKED: ({ label }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'N/A',
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label,
    name: 'documents_upload_tips_overlay_close_clicked',
    url: 'N/A',
  }),

  GO_TO_ACCOUNT_BUTTON_CLICKED: (url) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Go to account',
    category: DOCUMENT_CAPTURE_PAGES.REVIEW_STATUS,
    name: 'go_to_account_button_clicked',
    url,
  }),

  NEED_HELP_LINK_CLICKED: ({ buttonLabel }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: DOCUMENT_CAPTURE_PAGES.VEHICLE_DETAILS,
    label: 'Need help? clicked',
    name: 'need_help_link_clicked',
    url: 'N/A',
  }),

  OFFER_INFO_BIDS_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'offer_info_bids_clicked',
  }),

  OFFER_INFO_EXPIRY_MODAL_VIEWED: () => GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'offer_info_expiry_modal_viewed',
  }),

  OFFER_INFO_FAVOURITES_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'offer_info_favourites_clicked',
  }),

  OFFER_INFO_VIEWS_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    name: 'offer_info_views_clicked',
  }),

  PROOF_OF_ADDRESS_MISMATCH_INFOBOX_CLOSED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.PROOF_OF_ADDRESS,
    label: 'Address mismatch infobox closed',
    name: 'proof_of_address_mismatch_infobox_closed',
  }),

  UNDER_OFFER_SELF_SERVE_CONTACT_US_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Speak to us',
    category: DOCUMENT_CAPTURE_PAGES.ACCEPT_OFFER,
    label: 'N/A',
    name: 'under_offer_self_serve_contact_us_button_clicked',
    success: true,
    url: 'N/A',
  }),

  UPLOAD_DOCUMENTS_PAGE_LOADED: (label) => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.DOCUMENT_CAPTURE_UPLOAD,
    label,
    name: 'upload_documents_page_loaded',
  }),

  VEHICLE_DETAILS_LINK_CLICKED: ({ buttonLabel }) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: buttonLabel,
    category: DOCUMENT_CAPTURE_PAGES.SALE_CONFIRMATION,
    label: 'Vehicle details link clicked',
    name: 'vehicle_details_link_clicked',
    url: 'N/A',
  }),

  ViEW_DEALER_DETAILS_BUTTON_CLICKED: (url) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Dealer’s contact details',
    category: DOCUMENT_CAPTURE_PAGES.REVIEW_STATUS,
    name: 'view_dealer_details_button_clicked',
    url,
  }),

  WHAT_TO_EXPECT_LINK_CLICKED: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: DOCUMENT_CAPTURE_PAGES.REVIEW_STATUS,
    name: 'what_to_expect_link_clicked',
  }),
});
